import {
    LOGIN_ATTEMPT,
    LOGIN_SUCCESS,
    LOGIN_FAILED,
    LOGOUT,
    RESET_SUCCESS,
    UPDATE_FAILED,
    UPDATE_SUCCESS,
    SESSION_BOOTSTRAP_DONE,
    SESSION_HYDRATE,
} from "../types/sessionTypes";
import { loadUserProfile } from "../../api/userSessionStorage";

const cachedUser = typeof window !== "undefined" ? loadUserProfile() : null;

const INITIAL_STATE = {
    loading: false,
    auth: cachedUser || {},
    sessionReady: false,
    error: "",
    success: '',
    item: {}
};

function session(state = INITIAL_STATE, action) {
    switch (action.type) {
        case LOGIN_ATTEMPT:
            return {
                ...state,
                loading: true,
                error: "",
                success: ""
            };

        case SESSION_HYDRATE:
            return {
                ...state,
                auth: action.data,
                loading: false,
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                auth: action.data,
                loading: false,
                sessionReady: true,
            };
        case LOGIN_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
                auth: {},
            };
        case LOGOUT:
            return {
                ...INITIAL_STATE,
                auth: {},
                sessionReady: true,
            };
        case RESET_SUCCESS:
            return {
                ...state,
                success: action.success,
                error: ""
            };
        case UPDATE_FAILED:
            return {
                ...state,
                error: action.error,
                success: ""
            };
        case UPDATE_SUCCESS:
            return {
                ...state,
                auth: {
                    ...state.auth,
                    ...action.item,
                },
                loading: false,
                error: "",
                success: "",
                sessionReady: true,
            };
        case SESSION_BOOTSTRAP_DONE:
            return {
                ...state,
                sessionReady: true,
                loading: false,
            };
        default:
            return state;
    }
}
export default session;
